export default "__VITE_ASSET__CURS2bxd__"